// Analytics do SITE PÚBLICO (marketing/diretório/parceiros), gated por
// consentimento (LGPD). NÃO carrega no painel /app nem no fluxo do cliente.
const GA_ID = 'G-N8PCR93Y01';
const CLARITY_ID = 'xcr2qan3lf';
const KEY = 'lpt_consent';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    clarity?: (...args: unknown[]) => void;
  }
}

let started = false;

export function consentStatus(): 'granted' | 'denied' | null {
  const v = typeof localStorage !== 'undefined' ? localStorage.getItem(KEY) : null;
  return v === 'granted' || v === 'denied' ? v : null;
}

function injectGA() {
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer!.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false }); // page_view manual (SPA)
}

function injectClarity() {
  (function (c: Window, l: Document, a: 'clarity', r: 'script', i: string) {
    c[a] = c[a] || function () { (((c[a] as unknown) as { q: unknown[] }).q = ((c[a] as unknown) as { q: unknown[] }).q || []).push(arguments); };
    const t = l.createElement(r); t.async = true; t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0]; y.parentNode!.insertBefore(t, y);
  })(window, document, 'clarity', 'script', CLARITY_ID);
}

/** Inicia GA+Clarity se já houver consentimento (chamar no mount das páginas públicas). */
export function startAnalytics() {
  if (started || consentStatus() !== 'granted') return;
  started = true;
  injectGA();
  injectClarity();
}

export function setConsent(granted: boolean) {
  try { localStorage.setItem(KEY, granted ? 'granted' : 'denied'); } catch { /* ignore */ }
  if (granted) startAnalytics();
}

export function track(event: string, params?: Record<string, unknown>) {
  if (typeof window.gtag === 'function') window.gtag('event', event, params ?? {});
}

export function pageview(path: string, title?: string) {
  if (typeof window.gtag === 'function') window.gtag('event', 'page_view', { page_path: path, page_title: title });
}
